import React from 'react';
import DocumentiPratica from '../documenti/DocumentiPratica';

// Scheda "Documenti" della scheda cliente: la pratica dei documenti già disegnata (richiedi, da verificare, ricevuti,
// solo per noi, invii), con in cima "Fai firmare" (moduli e contratti di Impostazioni). La pratica ha il suo stile, per
// questo sta fuori dal riquadro della pagina.

export const TestaDocumenti = ({ apri }) => (
  <div className="testa-documenti r" data-testid="testa-documenti">
    <p className="muto">Richieste, da verificare, ricevuti, solo per noi, invii: la pratica completa del cliente.</p>
    <button type="button" className="btn sm p" onClick={() => apri('firma')}>Fai firmare</button>
  </div>
);

const TabDocumenti = ({ clienteId }) => (
  <div className="max-w-7xl mx-auto pb-12 sm:px-6 lg:px-8" style={{ marginTop: '-4rem', position: 'relative', zIndex: 1 }}>
    <DocumentiPratica clienteId={clienteId} />
  </div>
);

export default TabDocumenti;
